const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

/** 9999 y mayores se muestran como "Ilimitados" en lugar del número. */
export function formatSpacesLabel(value: number | string | null | undefined, plural = true): string {
  const n = Number(value);
  if (Number.isNaN(n) || n <= 0) return 'Sin límite';
  if (n >= 9999) return plural ? 'Ilimitados' : 'Ilimitado';
  return `${n} ${plural ? 'espacios' : 'espacio'}`;
}

/** Convierte una fecha ISO a formato humano en español: "Domingo 10 de agosto de 2026". */
export function formatLongDate(value: unknown): string {
  if (!value) return 'Sin fecha';
  let raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw = `${raw}T12:00:00`;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return String(value);
  const weekday = DIAS[date.getDay()];
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${date.getDate()} de ${MESES[date.getMonth()]} de ${date.getFullYear()}`;
}

/** Fecha humana con hora local: "Domingo 10 de agosto de 2026 · 2:30 PM". */
export function formatLongDateTime(value: unknown): string {
  if (!value) return 'Sin fecha';
  let raw = String(value).trim();
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = formatLongDate(date.toISOString());
  const time = new Intl.DateTimeFormat('es-SV', {
    hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'America/El_Salvador'
  }).format(date).replace(/\s*a\.\s*m\./i, ' AM').replace(/\s*p\.\s*m\./i, ' PM');
  return `${day} · ${time}`;
}

/** Convierte HH:mm[:ss] a la presentación local de 12 horas sin alterar el valor. */
export function formatClockTime(value: unknown): string {
  const match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})/);
  if (!match) return String(value || '');
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) return String(value || '');
  const period = hours >= 12 ? 'PM' : 'AM';
  return `${hours % 12 || 12}:${String(minutes).padStart(2, '0')} ${period}`;
}
